"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPageStatus = exports.getPageSort = exports.getPageSize = exports.getPageResults = exports.getPageParameters = exports.getPageNumber = exports.getPageFilter = exports.getPageError = exports.getPage = exports.getIsSinglePage = exports.getIsPageLoading = exports.getIsLastPage = exports.getIsFirstPage = exports.getIndexedEntities = exports.getAllResults = void 0;

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _get = _interopRequireDefault(require("lodash/get"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _pick = _interopRequireDefault(require("lodash/pick"));

var _values = _interopRequireDefault(require("lodash/values"));

var _PageStatus = _interopRequireDefault(require("./PageStatus"));

/**
 * Selects the indexed entities for the pagination slice in the application state.
 * @param {function} getPaginationState A function that returns the slice in
 * the application state containing the information interpreted by the
 * pagination reducer.
 * @returns {(state: object) => object} A function accepting the application state.
 */
var getIndexedEntities = function getIndexedEntities(getPaginationState) {
  return function (state) {
    var paginatedState = getPaginationState(state);
    return (0, _get.default)(paginatedState, 'entities');
  };
};
/**
 * Selects the current page number for the pagination slice in the
 * application state.
 * @param {function} getPaginationState A function that returns the slice in
 * the application state containing the information interpreted by the
 * pagination reducer.
 * @returns {(state: object) => number} A function accepting the application state.
 */


exports.getIndexedEntities = getIndexedEntities;

var getPageNumber = function getPageNumber(getPaginationState) {
  return function (state) {
    var paginatedState = getPaginationState(state);
    return (0, _get.default)(paginatedState, 'pagination.currentPage');
  };
};
/**
 * Selects the current page information for the pagination slice in the
 * application state.
 * @param {function} getPaginationState A function that returns the slice in
 * the application state containing the information interpreted by the
 * pagination reducer.
 * @returns {(state: object) => object} A function accepting the application state.
 */


exports.getPageNumber = getPageNumber;

var getPage = function getPage(getPaginationState) {
  return function (state) {
    var paginatedState = getPaginationState(state);
    var pageNumber = getPageNumber(getPaginationState)(state);
    return (0, _get.default)(paginatedState, ['pagination', 'pages', pageNumber]);
  };
};
/**
 * Selects the current page parameters for the pagination slice in the application state.
 * @param {*} getPaginationState
 */


exports.getPage = getPage;

var getPageParameters = function getPageParameters(getPaginationState) {
  return function (state) {
    var page = getPage(getPaginationState)(state);
    return (0, _get.default)(page, 'parameters');
  };
};
/**
 * Selects the number of records for the pagination slice in the
 * application state.
 * @param {function} getPaginationState A function that returns the slice in
 * the application state containing the information interpreted by the
 * pagination reducer.
 * @returns {(state: object) => number} A function accepting the application state.
 */


exports.getPageParameters = getPageParameters;

var getPageSize = function getPageSize(getPaginationState) {
  return function (state) {
    var parameters = getPageParameters(getPaginationState)(state);
    return (0, _get.default)(parameters, 'entriesPerPage');
  };
};
/**
 * Selects the current page error for the pagination slice in the
 * application state.
 * @param {function} getPaginationState A function that returns the slice in
 * the application state containing the information interpreted by the
 * pagination reducer.
 * @returns {(state: object) => Error} A function accepting the application state.
 */


exports.getPageSize = getPageSize;

var getPageError = function getPageError(getPaginationState) {
  return function (state) {
    var page = getPage(getPaginationState)(state);
    return (0, _get.default)(page, 'error');
  };
};
/**
 * Selects the current page results for the pagination slice in the
 * application state.
 * @param {function} getPaginationState A function that returns the slice in
 * the application state containing the information interpreted by the
 * pagination reducer.
 * @returns {(state: object) => object[]} A function accepting the application state.
 */


exports.getPageError = getPageError;

var getPageResults = function getPageResults(getPaginationState) {
  return function (state) {
    var entities = getIndexedEntities(getPaginationState)(state);
    var page = getPage(getPaginationState)(state);
    return (0, _values.default)((0, _pick.default)(entities, (0, _get.default)(page, 'entities')));
  };
};
/**
 * Selects the current page status for the pagination slice in the
 * application state.
 * @param {function} getPaginationState A function that returns the slice in
 * the application state containing the information interpreted by the
 * pagination reducer.
 * @returns {(state: object) => string} A function accepting the application state.
 */


exports.getPageResults = getPageResults;

var getPageStatus = function getPageStatus(getPaginationState) {
  return function (state) {
    var page = getPage(getPaginationState)(state);
    return (0, _get.default)(page, 'status');
  };
};
/**
 * Selects the filters applied to the current page for the pagination slice
 * in the application state.
 * @param {function} getPaginationState A function that returns the slice in
 * the application state containing the information interpreted by the
 * pagination reducer.
 * @returns {(state: object) => array} A function accepting the application state.
 */


exports.getPageStatus = getPageStatus;

var getPageFilter = function getPageFilter(getPaginationState) {
  return function (state) {
    var parameters = getPageParameters(getPaginationState)(state);
    return (0, _get.default)(parameters, 'filterBy');
  };
};
/**
 * Selects the sort fields applied to the current page for the pagination slice in the
 * application state.
 * @param {function} getPaginationState A function that returns the slice in the application state
 * containing the information interpreted by the pagination reducer.
 * @returns {(state: object) => array} A function accepting the application state.
 */


exports.getPageFilter = getPageFilter;

var getPageSort = function getPageSort(getPaginationState) {
  return function (state) {
    var parameters = getPageParameters(getPaginationState)(state);
    return (0, _get.default)(parameters, 'sortBy');
  };
};
/**
 * Returns whether the current page is the first page for the pagination slice
 * in the application state.
 * @param {function} getPaginationState A function that returns the slice in
 * the application state containing the information interpreted by the
 * pagination reducer.
 * @returns {(state: object) => boolean} A function accepting the application state.
 */


exports.getPageSort = getPageSort;

var getIsFirstPage = function getIsFirstPage(getPaginationState) {
  return function (state) {
    var page = getPage(getPaginationState)(state);
    return (0, _get.default)(page, 'isFirstPage');
  };
};
/**
 * Returns whether the current page is the last page for the pagination slice
 * in the application state.
 * @param {function} getPaginationState A function that returns the slice in
 * the application state containing the information interpreted by the
 * pagination reducer.
 * @returns {(state: object) => boolean} A function accepting the application state.
 */


exports.getIsFirstPage = getIsFirstPage;

var getIsLastPage = function getIsLastPage(getPaginationState) {
  return function (state) {
    var page = getPage(getPaginationState)(state);
    return (0, _get.default)(page, 'isLastPage');
  };
};
/**
 * Returns whether the current page is the only page for the pagination slice
 * in the application state.
 * @param {function} getPaginationState A function that returns the slice in
 * the application state containing the information interpreted by the
 * pagination reducer.
 * @returns {(state: object) => boolean} A function accepting the application state.
 */


exports.getIsLastPage = getIsLastPage;

var getIsSinglePage = function getIsSinglePage(getPaginationState) {
  return function (state) {
    var isFirstPage = getIsFirstPage(getPaginationState)(state);
    var isLastPage = getIsLastPage(getPaginationState)(state);
    return isFirstPage && isLastPage;
  };
};
/**
 * Returns whether the current page content is loading for the pagination slice
 * in the application state.
 * @param {function} getPaginationState A function that returns the slice in
 * the application state containing the information interpreted by the
 * pagination reducer.
 * @returns {(state: object) => boolean} A function accepting the application state.
 */


exports.getIsSinglePage = getIsSinglePage;

var getIsPageLoading = function getIsPageLoading(getPaginationState) {
  return function (state) {
    var page = getPage(getPaginationState)(state);
    return (0, _get.default)(page, 'status') === _PageStatus.default.LOADING;
  };
};
/**
 * Selects all the results up to the current page for the pagination slice
 * in the application state.
 * @param {function} getPaginationState A function that returns the slice
 * in the application state containing the information interpreted by the
 * pagination reducer.
 * @returns {(state: object) => object[]} A function accepting the whole
 * application state.
 */


exports.getIsPageLoading = getIsPageLoading;

var getAllResults = function getAllResults(getPaginationState) {
  return function (state) {
    var currentPage = getPage(getPaginationState)(state);

    if (currentPage == null) {
      return [];
    }

    var paginationState = getPaginationState(state);
    var entities = (0, _get.default)(paginationState, 'entities');
    var pages = (0, _get.default)(paginationState, 'pagination.pages');
    var currentPageParameters = (0, _omit.default)((0, _get.default)(currentPage, 'parameters'), 'pageNumber');
    var identifiers = (0, _keys.default)(pages).reduce(function (results, key) {
      var page = (0, _get.default)(pages, key);
      var pageParameters = (0, _omit.default)((0, _get.default)(page, 'parameters'), 'pageNumber');
      return (0, _isEqual.default)(currentPageParameters, pageParameters) ? results.concat(page.entities) : results;
    }, []);
    return (0, _values.default)((0, _pick.default)(entities, identifiers));
  };
};

exports.getAllResults = getAllResults;